import {Injectable} from "@angular/core";

@Injectable({providedIn: 'root'})
export class UserContextService {
    private readonly USER_ID_KEY = 'myKadaiSelectedUserId';

    setUserId(id: number): void {
        localStorage.setItem(this.USER_ID_KEY, id.toString());
    }

    getUserId(): number | null {
        const id = localStorage.getItem(this.USER_ID_KEY);
        return id ? +id : null;
    }

    clearUserId(): void {
        localStorage.removeItem(this.USER_ID_KEY);
    }
}
